// <auto-generated />
// ATENCAO: Arquivo auto-gerado pelo SetupController. Nao altere manualmente.

export const OC_STATUS = {
  Rascunho: 'OC_STATUS1',
  EmAprovacao: 'OC_STATUS5',
  Aprovada: 'OC_STATUS2',
  Emitida: 'OC_STATUS9',
  FaturadaParcialmente: 'OC_STATUS3',
  EncerradaParcialmente: 'OC_STATUS8',
  Encerrada: 'OC_STATUS4',
  Reprovada: 'OC_STATUS6',
  Cancelada: 'OC_STATUS7',
  // Mapa de sequencia (SequenciaLista) para lookup por codigo
  sequencia: {
    OC_STATUS1: 1,
    OC_STATUS5: 2,
    OC_STATUS2: 3,
    OC_STATUS9: 4,
    OC_STATUS3: 5,
    OC_STATUS8: 6,
    OC_STATUS4: 7,
    OC_STATUS6: 8,
    OC_STATUS7: 9
  }
}
